// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"142fda8c","9":"76c8665e","34":"5a092e0b","55":"b905dbfd","305":"2a5420ef","385":"dcb2853a","422":"b20a772a","572":"28291830","573":"71b22fcb","764":"8957e3bf","811":"96f2ce74","815":"53e2aa73","855":"5a671436","983":"09b479f5","996":"e1f12816"}[chunkId] + ".chunk.js";
};